export default "__VITE_ASSET__eTv61Jhv__"